import { render, staticRenderFns } from "./CtaBanner.vue?vue&type=template&id=0b04f7c3&scoped=true"
import script from "./CtaBanner.vue?vue&type=script&lang=js"
export * from "./CtaBanner.vue?vue&type=script&lang=js"
import style0 from "./CtaBanner.vue?vue&type=style&index=0&id=0b04f7c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04f7c3",
  null
  
)

export default component.exports